import { css } from '@emotion/react';
import { NumberValueInput } from 'folio-common-components';
import { formatters } from 'folio-common-utils';
import { colors } from 'folio-design-tokens';
import * as React from 'react';
import { OwnershipSummaryIcon } from '../../components/OwnershipSummary';
import { WarningIcon } from '../../icons';
import { type RootState, useActions, useSelector } from '../../state';

function selector(state: RootState) {
  return {
    info: state.editor.coreInfo,
    singleFounder: state.editor.ownershipType === 'single',
  };
}

export const ShareCapitalForm: React.FC = () => {
  const { info, singleFounder } = useSelector(selector);
  const { editorActions } = useActions();
  const numCapital = Number(info.capital.replace(/\s/g, '')) || 0;
  return (
    <form
      noValidate={true}
      onSubmit={evt => {
        evt.preventDefault();
      }}
    >
      <p>
        Selskapet må ha aksjekapital for å starte. Dette blir penger selskapet
        kan bruke av etterpå. Vi oppretter automatisk likt antall aksjer som det
        er kroner i aksjekapitalen.
      </p>

      <div
        css={css`
          width: 200px;
        `}
      >
        <NumberValueInput
          id="capital"
          onChange={capital =>
            editorActions.setCoreInfo({
              capital: capital.replace(/\s/g, ''),
            })
          }
          value={info.capital}
          autoComplete="off"
          message={
            (Number(info.capital) || 0) < 30000 ? { kind: 'error' } : undefined
          }
          aria-label="Aksjekapital"
          rightContent={{ content: 'kr', width: 13 }}
        />
      </div>

      {!singleFounder || numCapital >= 30000 ? null : (
        <p>
          <OwnershipSummaryIcon>
            <WarningIcon
              css={css`
                display: block;
              `}
              color={colors.red}
            />
          </OwnershipSummaryIcon>{' '}
          <span
            css={css`
              vertical-align: middle;
            `}
          >
            Aksjekapital må være minst{' '}
            {formatters.formatAmount(30000, {
              currency: 'kroner',
            })}
          </span>
        </p>
      )}
    </form>
  );
};
